import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import EllipsisWithTooltip from "./EllipsisWithTooltip";
import { Button, Chip, Typography } from "@material-ui/core";

function ExpandableChips({
  dataArray = [],
  attribute,
  incrementalLength = 10,
  ellipsisProps = {},
}) {
  const [records, setRecords] = useState([]);
  const [sliceLength, setSliceLength] = useState(incrementalLength);
  const [count, setCount] = useState();

  useEffect(() => {
    if (dataArray?.length > incrementalLength) {
      const slicedArray = dataArray?.slice(0, sliceLength);
      setRecords(slicedArray);
    } else {
      setRecords(dataArray);
    }
  }, [dataArray?.length]);

  useEffect(() => {
    setCount(dataArray?.length - records.length);
  }, [records.length]);

  return (
    <>
      {records.map((row, index) => {
        return (
          <Chip
            variant="default"
            clickable={false}
            label={
              <EllipsisWithTooltip
                text={attribute ? row[attribute] : row}
                {...ellipsisProps}
              />
            }
            style={{
              marginRight: "5px",
              marginBottom: "3px",
            }}
          />
        );
      })}

      {count > 0 && sliceLength <= dataArray?.length ? (
        <Typography>
          <Button
            color="primary"
            style={{
              marginTop: "2px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setRecords(dataArray?.slice(0, sliceLength + records.length));
              setSliceLength((prev) => prev + records.length);
            }}
          >
            + {count} More
          </Button>
        </Typography>
      ) : count === undefined ? (
        <></>
      ) : (
        dataArray?.length > incrementalLength && (
          <Typography>
            <Button
              color="primary"
              style={{
                marginTop: "2px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setRecords(dataArray?.slice(0, incrementalLength));
                setSliceLength(incrementalLength);
              }}
            >
              ...Less
            </Button>
          </Typography>
        )
      )}
    </>
  );
}

ExpandableChips.propTypes = {
  dataArray: PropTypes.arrayOf(PropTypes.any).isRequired,
  attribute: PropTypes.string,
  incrementalLength: PropTypes.any,
  ellipsisProps: PropTypes.any,
};

export default ExpandableChips;
